import { useAuthContextState } from "@AuthContext/store";
import { VisitFile } from "@Interface/visit";
import { Col, Empty, Layout, Modal, Row } from "antd";
import { useState } from "react";
import DicomViewer from "./dicom-viewer";
import Header from "./header";
import Sidebar from "./sidebar";

interface Props {
  visible: boolean;
  onCancel: () => void;
  urls: VisitFile[];
  visitId: string;
  haveCapture?: boolean;
  captureImage?: (currentImg: any) => void;
}
interface Series {
  id: string;
  imageUrl: string;
  maxFrames?: number;
  arrayBuffer?: ArrayBuffer;
}
const ModalViewer = ({
  visible,
  onCancel,
  urls,
  visitId,
  haveCapture = true,
  captureImage,
}: Props) => {
  const [selectedSeries, setSelectedSeries] = useState<any | null>(null);
  const [currentFrame, setCurrentFrame] = useState<number>(0);
  const [currentImg, setCurrentImg] = useState<string>("");
  const { token } = useAuthContextState();

  const series = urls?.map((item, index) => {
    return {
      id: (index + 1).toString(),
      imageUrl: item.fileUrl,
    };
  });
  const handleSelectSeries = (series: any) => {
    setSelectedSeries(series);
  };

  const handleScrollBarChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newFrame = parseInt(event.target.value, 10);
    setCurrentFrame(newFrame);
  };

  return (
    <Modal
      title="View DICOM"
      visible={visible}
      onCancel={onCancel}
      width={"100%"}
      style={{ top: 50 }}
      footer={false}
    >
      {!urls.length ? (
        <div>
          <Row justify="center" className="w-100">
            <Col span={24}>
              <Empty />
            </Col>
          </Row>
        </div>
      ) : (
        <Layout style={{ height: "80vh" }}>
          <Sidebar
            series={series}
            onSelectSeries={handleSelectSeries}
            visible={visible}
          />
          <Layout
            style={{
              marginInlineStart: 0,
              backgroundColor: "#000",
              height: "80vh",
            }}
          >
            <div style={{ height: "80vh" }}>
              {selectedSeries && (
                <div
                  style={{
                    height: "80vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    {haveCapture && (
                      <Header
                        currentImg={currentImg}
                        visitId={visitId}
                        token={token}
                        captureImage={captureImage}
                      />
                    )}
                  </div>
                  <div style={{ height: "80vh", overflow: "auto" }}>
                    <DicomViewer
                      imageId={selectedSeries?.imageId || ""}
                      setCurrentFrame={setCurrentFrame}
                      currentFrame={currentFrame}
                      currentImg={currentImg}
                      setCurrentImg={setCurrentImg}
                    />
                  </div>

                  <div style={{ paddingLeft: 24, paddingRight: 24 }}>
                    <span style={{ color: "white" }}>
                      ลากเพื่อเปลี่ยน frame
                    </span>
                    <span>
                      <input
                        type="range"
                        min="0"
                        max={selectedSeries?.maxFrames - 1}
                        value={currentFrame}
                        onChange={handleScrollBarChange}
                        style={{ width: "100%" }}
                      />
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingLeft: 5,
                      paddingRight: 5,
                      color: "white",
                    }}
                  >
                    <span style={{ color: "white" }}>
                      Series: {selectedSeries.id || 0}
                    </span>
                    <span style={{ textAlign: "right", color: "white" }}>
                      Frame: {currentFrame + 1} /
                      {selectedSeries?.maxFrames || 1}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </Layout>
        </Layout>
      )}
    </Modal>
  );
};
export default ModalViewer;
